/**
 * Header Component
 * Displays admin profile and logout button
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { useAdminAuth } from '../hooks/useAdminAuth';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { admin, logout } = useAdminAuth();
  const [showMenu, setShowMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
      {/* Title */}
      <div>
        <h2 className="text-xl font-semibold text-gray-900">Admin Dashboard</h2>
      </div>

      {/* Profile Menu */}
      <div className="relative">
        <button
          onClick={() => setShowMenu(!showMenu)}
          className="flex items-center space-x-3 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white">
            <User className="w-5 h-5" />
          </div>
          <div className="text-left">
            <p className="text-sm font-medium text-gray-900">{admin?.name || 'Admin'}</p>
            <p className="text-xs text-gray-500">{admin?.email}</p>
          </div>
        </button>

        {/* Dropdown Menu */}
        {showMenu && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
            <button
              onClick={handleLogout}
              className="w-full flex items-center space-x-2 px-4 py-3 text-left text-gray-700 hover:bg-gray-50 transition-colors border-t border-gray-200"
            >
              <LogOut className="w-4 h-4" />
              <span>Logout</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;

